import { GeckoMeasurementUnit } from 'types'

const EMAT_CATEGORY_EXCEL_VALUES: Record<number, number> = {
  0: 0,
  1: 6,
  2: 1,
  3: 2,
  4: 3,
  5: 4,
  6: 5,
}

export const getExcelDataValue = (
  value: number,
  measurementUnit: GeckoMeasurementUnit
) => {
  const isEmatCategory =
    measurementUnit.id === GeckoMeasurementUnit.EmatCustomCategory.id

  return isEmatCategory ? (EMAT_CATEGORY_EXCEL_VALUES[value] ?? value) : value
}
